import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { PROPERTY } from "./apiRoutes";

const mutateUpdateProperty = async ({
  id,
  data,
  communityId
}: {
  id: string;
  data: FieldValues;
  communityId: string;
}) => {
  return await axiosAuth.put(`${PROPERTY(communityId)}/${id}`, data);
};

const useUpdatePropertyMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
      communityId: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateProperty,
    ...queryParams,
  });

export default useUpdatePropertyMutation;
